// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  // import AnimatedView           from '../../../../components';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import styles                 from './style'
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog'
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import {
    AnimatedView,
    StatsTable,ScoreCard,StatsGraph
  }                         from '../../../components';
  import {Link} from 'react-router-dom';
  import ReactTooltip from 'react-tooltip';

  import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import { isNull } from 'util';
import device           from "current-device";

const is_mobile = device.mobile;  
const unbook_button_style={width:'120%',fontSize:'80%',height:'30px',color:'white',backgroundColor:'grey',};


  class PartnerBulkBooking extends PureComponent {
    static propTypes = {
      earningGraphLabels:   PropTypes.array,
      revenueChart:  PropTypes.shape({
        headers: PropTypes.array,


        data: PropTypes.array
      }),
      earningGraphDatasets: PropTypes.array,
      teamMatesIsFetching:  PropTypes.bool,
      teamMates:            PropTypes.arrayOf(
        PropTypes.shape({
          picture:      PropTypes.string,
          firstname:    PropTypes.string,
          lastname:     PropTypes.string,
          profile:      PropTypes.string,
          profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
        })
      ),
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        all_bulkbookings:[],
        days :[{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}],

        search:false,
        show_failed_slots : false,
        dialog_open_cust:true,
        selected_bulkbooking_id:'',
        isHovering:false,
        selected_id:'',
        loading:false,
        new_bulkbookings:[],
        datetime_with_booking_id:[],
        
      };
     this.getAllBulkBookings = this.getAllBulkBookings.bind(this);
     this.handleViewButton = this.handleViewButton.bind(this);
     this.cencleBulkbooking = this.cencleBulkbooking.bind(this);
     
    }
  
    componentDidMount() {
      this.getAllBulkBookings();
      

    
    }
    retryFailedSlots(id) {
      this.setState({selected_bulkbooking_id : id,loading:true});

      const url = `${getLocationOrigin()}/eagleeye/retry_for_bulkbookings/`;

            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'bulkbooking_id': id,
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) =>   {               
                
                window.location.reload();})
            .catch((error) => {
                console.log(error);
                alert(error.message);
                
            });

    }

    cencleBulkbooking(bulkbook) {
      
      console.log("cencleBulkbooking ")
      console.log(bulkbook.id)
      const url = `${getLocationOrigin()}/court_booking/cancel_bulk_booking/`;

            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'subscription_id': bulkbook.subscription,
                                'bulkbook_id':bulkbook.id,
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) =>   {   window.location.reload();            
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                
            });

    }
    
    handleViewButton(id){
      console.log("View Button clicked")
      console.log(id)
      if(this.state.show_failed_slots){
        this.setState({show_failed_slots:false,selected_id:null});
      }
      else {
        this.setState({show_failed_slots:true,selected_id:id});
      }
    }
    getAllBulkBookings(){
      
      const url = `${getLocationOrigin()}/eagleeye/get_bulkbookings_for_buddy/`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => { this.setState({ all_bulkbookings: data.bulkbooking});

                       }     
                )

         .catch(error => error);
      
    }
    downloadInvoicePress(bulkbook){
      this.downloadInvoice(bulkbook.subscription)
    }

    downloadInvoice(subscription_id){
      const url = `${getLocationOrigin()}/invoice/download/?subscription_id=${subscription_id}`;
      window.open(url);
    }

    
    render() {
      console.log('render')
      console.log(this.state)
      
      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleViewButton}
        />
      ];
      
  
      
    return(
        <div>
          <div className='row' style={{textAlign:'center'}}>
              <Link to={`./crud/addBulkBooking`}>
                        <FlatButton
                          backgroundColor="#ec407f"
                          className="flatbutton1"
                          label="Add Bulk Booking"
                          style={is_mobile()?{float:'center',width:'30%',textAlign:'left',marginLeft: '4px',paddingleft:'1%',paddingright:'1%'}:{float:'right',marginLeft: '5px',paddingleft:'1%',paddingright:'1%'}}
                        />
                      </Link>
                   
          </div>  
          <div className="col-md-12" style={{'padding':10,'display':"flex",'flexDirection':"row",}}>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'marginLeft':"2px",'width':"7.5%"}}>
                Created on
              </div>
              
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Date
              </div>  
              
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Time
              </div>
              
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"6%"}}>
                Courts
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"6%"}}>
                Days
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Customer
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Venue
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Created by
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Net Amount
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"90%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Remaining Amount
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"90%",'textAlign':"center",'marginRight':"1px",'width':"7%"}}>
                Failed Slots
              </div>
              <div className="col-md-1" style={{'backgroundColor':"#1CC9F3",'fontSize':"100%",'textAlign':"center",'marginRight':"1px",'width':"8%"}}>
                Last tried
              </div>
        </div>      
        <div className="col-md-12" style={{'padding':10,'marginRight':"1px",'width':"100%"}}>
          {this.state.all_bulkbookings.map((bulkbook, index)=>
            <div >
            {bulkbook.booking_status == 15 ? null :
             
            <div className="col-md-12" style={bulkbook.daily_failed_slots.length > 0 ?{'backgroundColor':'#FFCC9D','display':"flex",'flexDirection':"row",'margin':"2px",'paddingright':"5%",'width':"100%"} : {'width':"100%",'backgroundColor':'#cfd4d3','display':"flex",'flexDirection':"row",'margin':"2px",'paddingright':"5%"}}>
              

                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'display':"flex",'flexDirection':"column",'width':"8%"}}>
                {bulkbook.created_on.map((created_on,index) =>
                  <div>{created_on}
                  </div>
                  )}
                </div>
                
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'width':"8%"}}>
                {bulkbook.start_date.map((start_date,index) =>
                  <div>{start_date}
                  </div>
                  )}</div>
                
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'width':"8%"}}>
                {bulkbook.start_time.map((start_time,index) =>
                  <div>{start_time}
                  </div>
                  )}</div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'display':"flex",'flexDirection':"column",'width':"7%"}}>
                {bulkbook.court.map((crt,index) =>
                  <div>{crt.name}
                  </div>
                  )}
                </div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'display':"flex",'flexDirection':"column",'width':"7%",'marginLeft':"0%"}}>
                {bulkbook.days.map((d,i) =>
                  <div>
                  { this.state.days.map((day,index)=>{return (day.id == d && <div>{day.name}</div>) })}
                  </div>  
                  )}
                </div>
                <div className="col-md-1" style={bulkbook.type_of_booking == 0 ?{'textAlign':"center",'width':"8%",'marginLeft':"0px",'color':"blue",'fontSize':"140%"}:{'fontSize':"100%",'textAlign':"center",'width':"8%",'marginLeft':"0px"}}>
                <div >
                {bulkbook.type_of_booking == 0 ?
                bulkbook.reason_of_booking:
                bulkbook.customer}
                </div>

                </div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'width':"8%",'marginLeft':"0px"}}>{bulkbook.venue}</div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'marginLeft':"2px",'width':"8%",'marginRight':"0px"}}>{bulkbook.buddy}</div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'width':"8%",'marginRight':"0px"}}>{bulkbook.net_amount}</div>
                <div className="col-md-1" style={bulkbook.reamining_amount > 0 ?{'fontSize':"120%",'textAlign':"center",'width':"8%",'marginRight':"5px",'color':"red"}:{'fontSize':"100%",'textAlign':"center",'width':"8%",'marginRight':"5px"}}>{bulkbook.reamining_amount}</div>
                <div className="col-md-1" style={bulkbook.daily_failed_slots.length > 0 ? {'fontSize':"150%",'textAlign':"center",'width':"8%",'marginRight':"-7px",'color':"red"}:{'fontSize':"100%",'textAlign':"center",'width':"8%",'marginRight':"-7px"}}>{bulkbook.daily_failed_slots.length}</div>
                <div className="col-md-1" style={{'fontSize':"100%",'textAlign':"center",'display':"flex",'flexDirection':"column",'width':"10%"}}>
                {bulkbook.updated_on.map((updated_on,index) =>
                  <div>{updated_on}
                  </div>
                  )}
                </div>
                <div  className="col-md-1" style={{'align':"center",'padding':"20px",'display':"flex",'flexDirection':"row"}}>
                    <input type="button" value="View" style={{'textAlign':"center"}}  onClick={() => this.handleViewButton(bulkbook.id)}/>
                    {this.state.selected_id == bulkbook.id  &&
                      <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                          <Dialog
                            actions={okaction}
                            modal={false}
                            open={bulkbook.daily_failed_slots}
                            onClick={this.handleViewButton}
                            autoDetectWindowHeight={true}
                            autoScrollBodyContent={true}
                            scroll={scroll}
                            dividers={scroll === 'paper'}
                          >
                            <div style={styles.main_header} className="col-md-12">
                              <h4 style={{textAlign:'center'}}>Following Slots are Failed to Book</h4>
                            </div>
                            <div style={{'fontSize':"100%",'textAlign':"center",'display':"flex",'flexDirection':"row",'float':"right"}}>
                                  <div  style={{'align':"center",'padding':"5px"}}>
                                   <button style={{'textAlign':"center",'backgroundColor':"#55dee0"}}  onClick={() => {this.cencleBulkbooking(bulkbook)}}>Cancel Bulkbooking</button>
                                   </div>
                                  {bulkbook.daily_failed_slots.length > 0 &&
                                  <div style={{'float':"right",'marginTop':"5px"}} >
                                    <input type="button" style={{'backgroundColor':"#55dee0"}} value="Click to Retry" onClick={() => this.retryFailedSlots(bulkbook.id)}/>
                                  </div>
                                  }
                            </div>
                            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                              <div >
                                Total Failed Slots
                              </div>
                            </div>
                            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                              <div >
                                {bulkbook.daily_failed_slots.length}
                              </div>
                            </div>
                            
                            {bulkbook.daily_failed_slots.length > 0 &&
                            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center', marginTop:10}}>
                              <div className="col-md-4">
                                Date
                              </div>
                              <div className="col-md-4">
                                Court 
                              </div>
                              <div className="col-md-4">
                                Time
                              </div>
                              </div>
                            }
                            {bulkbook.daily_failed_slots.length > 0 ?
                            
                            <div>
                              {bulkbook.daily_failed_slots.map((list,index)=>
                              <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                                  <div className="col-md-4">
                                    {list.date}
                                  </div>
                                  <div className="col-md-4">
                                    {list.court.name}
                                  </div>
                                  <div className="col-md-4">
                                    {list.start_time}
                                  </div>
                              </div>
                                )}
                            </div>
                            
                          
                                :
                                null
                            }
                            
                            
                        </Dialog>
                    </div>
                    
                  }
               </div>
                <div  className="col-md-1" style={{'align':"center",'padding':"20px"}}>
               <input type="button" value="Invoice" style={{'textAlign':"center"}} onClick={()=>{this.downloadInvoicePress(bulkbook)}} />
               </div>
               
            </div>
            }
            </div>
            )}
          </div>

       
      </div>  
      );
    }
  }
  
  export default PartnerBulkBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerBulkbooking/PartnerBulkbooking.js